import { render, staticRenderFns } from "./makedir.vue?vue&type=template&id=0ac438f3&scoped=true"
import script from "./makedir.vue?vue&type=script&lang=js"
export * from "./makedir.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac438f3",
  null
  
)

export default component.exports